export const RTBLogo = ({ className = "h-8", dark = false }) => (
  <div className={`flex items-center gap-1.5 ${className}`}>
    <div className="flex items-center">
      <span className="font-oswald font-bold text-2xl tracking-tight">
        <span className={dark ? "text-white" : "text-rtb-purple"}>RTBI</span>
      </span>
    </div>
    <div className="w-px h-6 bg-current opacity-20" />
    <span className="font-manrope text-[10px] font-semibold uppercase tracking-widest leading-tight opacity-50">
      Ready To<br />Build It
    </span>
  </div>
);
